<su-headline h="h1" skin="primary">{{
  'access_orderer.title' | translate
}}</su-headline>

<div class="button-container">
  <su-button
    skin="secondary"
    icon="book-open"
    [label]="'access_orderer.history.title' | translate"
    (click)="openHistory()">
  </su-button>

  <su-button
    *ngIf="canEditRepresentatives$ | async"
    skin="primary"
    [label]="'access_orderer_representative.title' | translate"
    (click)="navigateToRepresentatives()">
  </su-button>
</div>

<div
  style="
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 25px;
  ">
  <form [formGroup]="form" style="width: 80%; margin-bottom: 10px">
    <formly-form
      [fields]="filterFields"
      [form]="form"
      [model]="formModel"></formly-form>
  </form>
</div>

<su-button
  skin="primary"
  icon="plus"
  [disabled]="!selectedEmployee"
  [label]="'access_orderer.user.button_add' | translate"
  (click)="openDialogAddAccessOrderer()">
</su-button>
<br /><br />

<mtx-grid
  #grid
  [columns]="columns"
  [data]="data.items"
  [loading]="isLoading"
  [length]="data.totalCount"
  [pageOnFront]="true"
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [rowStriped]="true"
  [rowHover]="true"
  [cellSelectable]="false"
  [showSidebar]="true"
  [hideRowSelectionCheckbox]="false"
  [showColumnMenuButton]="false">
</mtx-grid>

<ng-template #addExtendTemplate let-row let-index="index" let-col="colDef">
  <div class="button-container-add-extend">
    <su-button
      *ngIf="!row.accessOrdererEnddate"
      skin="primary"
      icon="check"
      [matTooltip]="'access_orderer.list.add_extend' | translate"
      (click)="openDialogAccessOrderer(row, 'add')"
      [ariaLabel]="'access_orderer.list.add_extend' | translate">
    </su-button>
    <su-button
      *ngIf="row.isExtendable"
      skin="primary"
      icon="check"
      [matTooltip]="'access_orderer.list.add_extend' | translate"
      (click)="openDialogAccessOrderer(row, 'extend')"
      [ariaLabel]="'access_orderer.list.add_extend' | translate">
    </su-button>
  </div>
</ng-template>

<ng-template #endTemplate let-row let-index="index" let-col="colDef">
  <su-button
    *ngIf="row.accessOrdererEnddate"
    skin="secondary"
    icon="x"
    (click)="openDialogAccessOrderer(row, 'end')"
    [matTooltip]="'access_orderer.list.end' | translate"
    [ariaLabel]="'access_orderer.list.end' | translate">
  </su-button>
</ng-template>

<app-spinner-overlay [show]="loading" label=""></app-spinner-overlay>
